import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { FaBars } from "react-icons/fa";
import { graphql, useStaticQuery } from "gatsby";
import NavDropdown from "react-bootstrap/NavDropdown";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Navbar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background-color: #ffffff;
  top: ${({ hidden }) => (hidden ? "-100px" : "0")};
  transition: top 0.3s;
  position: fixed;
  width: 100%;

  .logo_icon_with_text{
    width:151px;
  }

  .logo_icon_with_text--tablet{
    @media screen and (min-width: 1025px){
      display: none;
    }

    @media screen and (max-width: 500px){
      display: none;
    }
  }

  .logo_icon_with_text--mobile{
    @media only screen and (min-width: 501px){
      display: none;
    }
  }

  .navbar--center{
    width:95%;
    max-width: 1440px;
    display:flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;

    .navLink{
      border: none;
      white-space: nowrap;
      text-align: center;
      background:transparent;
      /* width:100%; */
      margin: 0 5px;
      
      & a:hover{
          color: var(--orange);
      }

      & a,span{
        text-decoration: none;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
        letter-spacing: -0.005em;
        color:var(--blue);

        @media only screen and (max-width: 1250px){
          font-size: 16px;
        }

        @media only screen and (max-width: 1024px){
          font-size: 14px;
        }
      }

      & .active-link {
        /* color: var(--orange); */
        border-bottom: 1px solid var(--orange);
      }
      
      @media only screen and (min-width: 901px){
        margin: 0 9px;
      }

      @media only screen and (min-width: 1251px){
        margin: 0 14px;
      }

      
      
      //navLink's media query
      @media only screen and (max-width:1024px){
        padding: 1rem 0;
        border-top: 1px solid var(--blue);
        width: 100%;
      }
    }

    //navbar--center's media query
    @media only screen and (max-width:1024px){
      flex-direction:column;
      width:100%;
      padding: 0 1rem;
      justify-content: space-around;
      
    }
  }
`;

const NavHeader = styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
  height: 6rem;
  width:100%;
  padding-left: 3rem;
  padding-right: 3rem;
  /* margin-bottom: 6rem; */

  .fa-bars{
    color:var(--orange);
  }

  .test{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media only screen and (max-width: 1024px){
      display:none;
    }
  }

  @media screen and (min-width: 1025px) {
    .navHeader__btn{
      display:none;
    }
  }

  @media screen and (max-width: 1024px){
    column-gap: 1rem;

    .navHeader__btn{
      background-color: transparent;
      border: none;
      font-size: 22px;
    }
  }

  @media screen and (max-width: 1440px){
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const NavLinks = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-evenly;
  width:90%;

  @media only screen and (max-width: 1024px){
    display:none;
  }
`;

const ContactLink = styled.div`

  a{
    text-decoration: none;
  }

  .contactLink__btn{
    border: 1px solid var(--orange);
    border-radius: 2rem;
    background: var(--orange);
    white-space: nowrap;

    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    letter-spacing: -0.005em;
    width:131px;
    height:26px;
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color:#ffffff;

    /* & a{
      text-decoration: none;
      color:#ffffff;
    } */

    &:hover{
      color: var(--orange);
      background-color: #ffffff;
    }
    
    @media only screen and (max-width: 1250px){
      font-size: 16px;
      width: 130px;
      /* padding: 0.75rem 0; */
    }

    @media only screen and (max-width: 1024px){
      font-size: 14px;
      padding: 0.5rem 0;
      
    }

    @media only screen and (max-width: 1000px){
      width:80px;
    }

    @media only screen and (max-width: 768px){
      padding: 0;
      width: 150px;
    }

    @media only screen and (max-width: 500px){
      width: 80px;
    }

    
  }

  @media only screen and (max-width: 1024px){
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (max-width: 500px){
    width: auto;
  }
`;

const HamburgerLinks = styled.div`
  height: ${({ show }) => show ? "auto" : "0"};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  width: 100%;
  background-color: #ffffff;

  .accordion-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    row-gap: 0.5rem;
    width: 100%;
    padding: 1rem 0;
  }

  .mobile-navLink {
    width: 100%;
    text-align: center;
    padding: 0.75rem 0;
    border-top: 1px solid var(--blue);
  }

  .mobile-navLink:last-child {
    border-bottom: 1px solid var(--blue);
  }

  .mobile-navLink a {
    text-decoration: none;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    color: var(--blue);
  }

  .mobile-dropdown {
    width: 100%;
    text-align: center;
    padding: 0.75rem 0;
    border-top: 1px solid var(--blue);
    position: relative;
  }

  .mobile-dropdown-title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    color: var(--blue);
    margin-bottom: 0.5rem;
  }

  .mobile-dropdown-menu {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    padding: 0.5rem 0;
  }

  .mobile-dropdown-item {
    text-decoration: none;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: var(--blue);
    padding: 0.25rem 0;
  }
  
  @media only screen and (min-width: 1025px){
    display: none;
  }
`;

const NavBar = () => {
  const [show, setShow] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [hidden, setHidden] = useState(false);
  const [scrollTimeout, setScrollTimeout] = useState(null);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [expertiseOpen, setExpertiseOpen] = useState(false);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > scrollY) {
      setHidden(true); // Hide navbar on scroll down
    } else {
      // Set a delay before showing the navbar
      clearTimeout(scrollTimeout);
      setScrollTimeout(
        setTimeout(() => {
          setHidden(false); // Show navbar on sustained scroll up
        }, 300) // Delay of 300ms
      );
    }
    setScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY]);

  const data = useStaticQuery(graphql`
    query NavBarQuery {
      contentfulAsset(title: { eq: "Nav Bar - FFG Logo" }) {
        gatsbyImageData(placeholder: BLURRED, quality: 100)
      }
    }
  `);

  return (
    <Navbar hidden={hidden}>
      <div className="navbar--center">
        <NavHeader>
          <button className="navHeader__btn" onClick={() => setShow(!show)}>
            <FaBars className="fa-bars" />
          </button>
          <div className="test">
            <Link to="/">
              <GatsbyImage
                alt="logo"
                className="logo_icon_with_text"
                image={getImage(data.contentfulAsset.gatsbyImageData)}
              />
            </Link>
            <NavLinks>
              {/* <button className='navLink'><Link activeClassName='active-link' onClick={() => setShow(false)} to="/">Home</Link></button> */}
              <NavDropdown className='navLink' id="basic-nav-dropdown" title="Services">
                <NavDropdown.Item className="!text-left" href="/our-services">Our Services</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item className="!text-left" href="/services/social-advertising">Social Advertising</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/services/ppc-and-sem">PPC & SEM</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/services/email-marketing">Email Marketing</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/services/sms-marketing">SMS Marketing</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/services/data-and-conversion-tracking">Data & Conversion Tracking</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/services/design">Design</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown className='navLink' id="expertise-dropdown" title="Expertise">
                <NavDropdown.Item className="!text-left" href="/expertise/ecommerce">eCommerce</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/expertise/b2b">B2B</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/expertise/cannabis">Cannabis</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/expertise/saas">SaaS</NavDropdown.Item>
                <NavDropdown.Item className="!text-left" href="/expertise/experimental">Experimental</NavDropdown.Item>
              </NavDropdown>
              <button className='navLink'><Link activeClassName='active-link' onClick={() => setShow(false)} to="/our-company">Our Company</Link></button>
              <button className='navLink'><Link activeClassName='active-link' onClick={() => setShow(false)} to="/case-studies">Case Studies</Link></button>
              <button className='navLink'><Link activeClassName='active-link' onClick={() => setShow(false)} to="/category/all">Blogs</Link></button>
              {/* <button className='navLink'><Link activeClassName='active-link' onClick={() => setShow(false)} to="/careers">Careers</Link></button> */}
        
            </NavLinks>
          </div>
          <Link to="/">
            <GatsbyImage
              alt="logo"
              className="logo_icon_with_text logo_icon_with_text--mobile"
              image={getImage(data.contentfulAsset.gatsbyImageData)}
            />
          </Link>
          <ContactLink>
            <Link
              activeClassName="active-link"
              className="contactLink__btn"
              onClick={() => setShow(false)}
              to="/contact-us"
            >
              Hire Us
            </Link>
          </ContactLink>
        </NavHeader>
        <HamburgerLinks show={show}>
          <div className="accordion-content">
            <div className="mobile-dropdown">
              <div 
                className="mobile-dropdown-title" 
                onClick={() => setServicesOpen(!servicesOpen)}
              >
                Services
              </div>
              {servicesOpen && (
                <div className="mobile-dropdown-menu">
                  <Link className="mobile-dropdown-item" to="/our-services" onClick={() => setShow(false)}>
                    Our Services
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/social-advertising" onClick={() => setShow(false)}>
                    Social Advertising
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/ppc-and-sem" onClick={() => setShow(false)}>
                    PPC & SEM
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/email-marketing" onClick={() => setShow(false)}>
                    Email Marketing
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/sms-marketing" onClick={() => setShow(false)}>
                    SMS Marketing
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/data-and-conversion-tracking" onClick={() => setShow(false)}>
                    Data & Conversion Tracking
                  </Link>
                  <Link className="mobile-dropdown-item" to="/services/design" onClick={() => setShow(false)}>
                    Design
                  </Link>
                </div>
              )}
            </div>
            
            <div className="mobile-dropdown">
              <div 
                className="mobile-dropdown-title" 
                onClick={() => setExpertiseOpen(!expertiseOpen)}
              >
                Expertise
              </div>
              {expertiseOpen && (
                <div className="mobile-dropdown-menu">
                  <Link className="mobile-dropdown-item" to="/expertise/ecommerce" onClick={() => setShow(false)}>
                    eCommerce
                  </Link>
                  <Link className="mobile-dropdown-item" to="/expertise/b2b" onClick={() => setShow(false)}>
                    B2B
                  </Link>
                  <Link className="mobile-dropdown-item" to="/expertise/cannabis" onClick={() => setShow(false)}>
                    Cannabis
                  </Link>
                  <Link className="mobile-dropdown-item" to="/expertise/saas" onClick={() => setShow(false)}>
                    SaaS
                  </Link>
                  <Link className="mobile-dropdown-item" to="/expertise/experimental" onClick={() => setShow(false)}>
                    Experimental
                  </Link>
                </div>
              )}
            </div>
            
            <div className="mobile-navLink">
              <Link activeClassName='active-link' onClick={() => setShow(false)} to="/our-company">
                Our Company
              </Link>
            </div>
            
            <div className="mobile-navLink">
              <Link activeClassName='active-link' onClick={() => setShow(false)} to="/case-studies">
                Case Studies
              </Link>
            </div>
            
            <div className="mobile-navLink">
              <Link activeClassName='active-link' onClick={() => setShow(false)} to="/category/all">
                Blogs
              </Link>
            </div>
          </div>
        </HamburgerLinks>
      </div>
    </Navbar>
  );
};

export default NavBar;